import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})

export class HeaderComponent implements OnInit {
  isMobile: boolean = false;
  currentLang: any = localStorage.getItem('language') || 'id';

  constructor(
    public translate: TranslateService,
  ) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.currentLang = localStorage.getItem('language') !== null ? localStorage.getItem('language') : 'id';

      let platform = localStorage.getItem('platform');

      // if (platform !== 'indossat') {
      //   this.isMobile = true;
      // }

      console.log({ platform, isMobile: this.isMobile, lang: this.currentLang });
    }, 500);
  }

  changeLang(lang: string) {
    localStorage.setItem('language', lang);
    this.currentLang = lang;
    this.translate.use(lang);
  }

  backToHome() {
    window.location.href = '/'
  }

}
